<template>
  <div class="one_step">
    <div class="step_shell for_pb">
      <h2 class="details_header">{{header}}</h2>
      <h3 class="details_subheader">
        Please provide the following details for the last financial year
      </h3>
      <div class="field_wrap money_wrap">
        <span class="field_label" v-text="incomeQuestionText"></span>
        <v-currency-field
          data-test-id="step-3-income"
          outlined
          v-model="Farm_Income"
          prefix="$"
          color="#0200b9"
          class="money_field"
          :rules="amount_rules"
          maxlength="15"
        />
      </div>
      <div class="field_wrap money_wrap">
        <span class="field_label" v-text="costQuestionText"></span>
        <v-currency-field
          data-test-id="step-3-costs"
          outlined
          v-model="Farm_Cost"
          prefix="$"
          color="#0200b9"
          class="money_field"
          :rules="amount_rules"
          maxlength="15"
        />
      </div>
      <div class="field_wrap money_wrap">
        <span class="field_label" v-text="drawingsQuestionText"></span>
        <v-currency-field
          data-test-id="step-3-drawings"
          outlined
          v-model="Farm_Owner_Drawings"
          prefix="$"
          color="#0200b9"
          class="money_field"
          :rules="amount_rules_can_be_zero"
          maxlength="15"
        />
      </div>

      <div class="field_wrap textfield_wrap">
        <span class="field_label">Please provide any additional details to support your application below.</span>
        <v-textarea
          data-test-id="step-4-firstname"
          outlined
          v-model="Additional_Details"
          color="#0200b9"
          auto-grow
          class="text_field"
        />
      </div>
    </div>
  </div>
</template>

<script>
import libraryMixin from './library_mixin';

export default {
  mixins: [libraryMixin],
  props: {
    current: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      stepIndex: 3,
      valid: false,  
      Farm_Income: null,
      Farm_Cost: null,
      Farm_Owner_Drawings: null,
      Additional_Details: null,
      amount_rules: [
        function(v){ return (v !== 0 && !!v) || 'Please complete this field'}
      ],
      amount_rules_can_be_zero: [
        function(v){ return (!!v) || 'Please complete this field'}
      ]
    };
  },
  watch: {
    current: {
      handler(val) {
        if (val) {
          this.showToast = true;
        }
      }
    }
  },
  computed: {
      purpose : function purpose(){
        return this.$parent.$parent.application.purpose
      },
      incomeQuestionText: function incomeQuestionText(){
          switch (this.purpose) {
              case 'buy' : return "What was the farm's gross income last year?"; break;
              case 'refinance' : return "What was the farm's gross income last year?"; break;
              case 'both' : return "What was the gross income last year for both farms combined?"; break;
              default: return "What was the farm's gross income last year?"
          }
      },
      costQuestionText: function costQuestionText(){
          switch (this.purpose) {
              case 'buy' : return "What were the farm's operating costs last year? (excluding interest and owner drawings)"; break;
              case 'refinance' : return "What were the farm's operating costs last year? (excluding interest and owner drawings)"; break;
              case 'both' : return "What were the combined operating costs of the farms last year? (excluding interest and owner drawings)"; break;
              default: return "What were the farm's operating costs last year? (excluding interest and owner drawings)"
          }
      },
      drawingsQuestionText: function drawingsQuestionText(){
          switch (this.purpose) {
              case 'buy' : return "What were the farm's annual owner drawings? "; break;
              case 'refinance' : return "What were the farm's annual owner drawings? "; break;
              case 'both' : return "What were the annual owner drawings of both farms combined? "; break;
              default: return "What were the farm's annual owner drawings? "
          }
      },
      financeInfo: function financeInfo(){
          return {
              Farm_Income: this.Farm_Income,
              Farm_Cost: this.Farm_Cost,
              Farm_Owner_Drawings: this.Farm_Owner_Drawings,
              Additional_Details: this.Additional_Details
          }
      },
  },
  updated: function() {
    this.immediateDataUpdate();
  },
  methods: {
    updateData: function updateData() {
      this.valid = this.checkValidity();
      this.$emit("updateFinanceInfo", this.financeInfo);
      this.$emit("stepValid", { step: 3, valid: this.valid });
      this.$emit("sendDataToAPI");
    },
    checkValidity: function checkValidity(){
      var this_data = [
        !!this.Farm_Income,
        !!this.Farm_Cost,
        this.Farm_Owner_Drawings !== null
      ]
      var isvalid = this_data.every(function(el){ return el });

      return isvalid;
    }
  },
  created: function() {
    var app_data = this.$parent.$parent.application.financeInfo;
    
    this.Farm_Income = app_data.Farm_Income ? app_data.Farm_Income : null
    this.Farm_Cost = app_data.Farm_Cost ? app_data.Farm_Cost : null
    this.Farm_Owner_Drawings = app_data.Farm_Owner_Drawings ? app_data.Farm_Owner_Drawings : null
    this.Additional_Details = app_data.Additional_Details ? app_data.Additional_Details : null
  }
};
</script>